import type React from 'react'

import { clsJoin } from '@/utils'
import { CheckIcon } from './components/CheckIcon'
import css from './styles.module.css'

interface Props {
  activeSlide: number
  items: string[]
  onClick: (index: number) => void
}

export const Features: React.FC<Props> = ({ activeSlide, items, onClick }) => (
  <div className={css.features}>
    {items.map(
      (item, index) =>
        item && (
          <div
            key={index}
            className={clsJoin(
              css.features_item,
              activeSlide === index && css.checked
            )}
            onClick={() => onClick(index)}
          >
            <CheckIcon checked={activeSlide === index} />
            <div className={css.features_item_name}>{item}</div>
          </div>
        )
    )}
  </div>
)
